var _path, _path2, _path3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 23C28 22.4477 27.5523 22 27 22C26.4477 22 26 22.4477 26 23V24H25C23.3431 24 22 25.3431 22 27V39C22 40.6569 23.3431 42 25 42H33.6822C32.9121 41.488 32.2671 40.8028 31.8027 40H25C24.4477 40 24 39.5523 24 39V27C24 26.4477 24.4477 26 25 26H26V27C26 27.5523 26.4477 28 27 28C27.5523 28 28 27.5523 28 27V26H36V27C36 27.5523 36.4477 28 37 28C37.5523 28 38 27.5523 38 27V26H39C39.5523 26 40 26.4477 40 27V31.8027C40.8028 32.2671 41.488 32.9121 42 33.6822V27C42 25.3431 40.6569 24 39 24H38V23C38 22.4477 37.5523 22 37 22C36.4477 22 36 22.4477 36 23V24H28V23Z",
    fill: "#272B30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 41C39.2091 41 41 39.2091 41 37C41 34.7909 39.2091 33 37 33C34.7909 33 33 34.7909 33 37C33 39.2091 34.7909 41 37 41ZM37 43C40.3137 43 43 40.3137 43 37C43 33.6863 40.3137 31 37 31C33.6863 31 31 33.6863 31 37C31 40.3137 33.6863 43 37 43Z",
    fill: "#272B30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 34C37.5523 34 38 34.4477 38 35V36.5858L38.7071 37.2929C39.0976 37.6834 39.0976 38.3166 38.7071 38.7071C38.3166 39.0976 37.6834 39.0976 37.2929 38.7071L36.2929 37.7071C36.1054 37.5196 36 37.2652 36 37V35C36 34.4477 36.4477 34 37 34Z",
    fill: "#272B30"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 62,
    rx: 31,
    stroke: "#EFEFEF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProduct);
export default __webpack_public_path__ + "static/media/add_product.2d2091d9fba2df5447b9c9837de42719.svg";
export { ForwardRef as ReactComponent };